// extracted by mini-css-extract-plugin
export default {"container":"CompletionScript_container__N4ny-","hint":"CompletionScript_hint__fvoEM"};